import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import { getNestedValue } from "../functions/objectMethods";
import moment from "moment-timezone";

export default new Vuex.Store({
  state: {
    settings: {
      user_id: 1234,
      theme: "Grey",
      primaryLanguage: "English",
    },
    weather: {
      temp: "",
      type: undefined,
    },
    languagePacks: {
      English: {
        name: "Name",
        time: "Time",
        status: "Status",
        employee: "Employee",
        category: "Category",
        seat: "Seat/Room",
        login: "Login",
        username: "Username",
        password: "Password",
        statusMap: {
          1: "Waiting",
          2: "Now Serving",
          3: "Cancel",
          4: "Done",
        },
      },
      Français: {
        name: "Nom",
        time: "Temps",
        status: "Statut",
        employee: "Employée",
        category: "Catégorie",
        seat: "Siège/Salle",
        login: "S'Identifier",
        username: "Nom d'Utilisateur",
        password: "Mot de Passe",
        statusMap: {
          1: "Waiting",
          2: "Now Serving",
          3: "Cancel",
          4: "Done",
        },
      },
      Spanish: {
        name: "Nombre",
        time: "Hora",
        status: "Estatus",
        employee: "Empleado",
      },
    },
    themeMap: {
      red: { primary: "#C62828", secondary: "#757575" },
      blue: { primary: "#42A5F5", secondary: "#757575" },
    },
    ad: undefined,
    imageCache: {},
    columnSettings: {},
    channel: undefined,
    userId: undefined,
    token: undefined,
    slides: [],
    slideDuration: 15,
    currentBookings: [],
    todaysBookings: [],
    compnay: {},
  },
  getters: {
    // settings
    getDeviceId(state) {
      return state.settings.device_id;
    },
    getTheme(state) {
      return state.settings.theme;
    },
    getLanguage(state) {
      return state.settings.primaryLanguage;
    },
    getWeather(state) {
      return state.weather;
    },
    getLabelByKey: (state) => (key, language) =>
      getNestedValue(state.languagePacks, [language, key], ""),
    primaryLanguage: (state) =>
      getNestedValue(state.settings, "primaryLanguage", "English"),
    getAd: (state) => state.ad,
    getColumnSettings: (state) => state.columnSettings,
    getFilteredBookings: (state) => state.filteredBookings,
    getTodaysBookings: (state) => state.todaysBookings,
    userId: (state) => state.userId,
    token: (state) => state.token,
    getSlides: (state) => state.slides,
    getSlideDuration: (state) => state.slideDuration,
    showEntireDaysBookings: (state) => state.settings.showEntireDaysBookings,
    company: (state) => state.company,
  },
  actions: {
    initialize({ commit, state }) {
      setInterval(() => {
        const now = Date.now();
        Object.keys(state.imageCache).map((cacheKey) => {
          if (now - state.image[cacheKey].last_used > 1000 * 60 * 60) {
            commit("CLEAR_CACHE_ENTRY", cacheKey);
          }
        });
      }, 1000 * 60 * 10);
    },
    setSettings({ commit }, settings) {
      commit("SET_SETTINGS", settings);
    },
    subscribe({ commit, dispatch }, { channel }) {
      let pusherChannel = pusher.subscribe(channel);
      dispatch("getCurrentBookings");
      commit("UPDATE_CHANNEL", channel);
      pusherChannel.bind("update-channel", () => {
        dispatch("getCurrentBookings");
      });
      pusherChannel.bind("live-display-settings-changed", () => {
        dispatch("getLiveSettings");
      });
    },
    unsubscribe({ state }) {
      pusher.unsubscribe(state.channel);
    },
    updateWeather({ commit }, data) {
      commit("UPDATE_WEATHER", data);
    },
    async getCurrentBookings({ commit, dispatch }) {
      window
        .axios({
          method: "get",
          url: "/booking/getAllCurrentBookingsBySalon",
        })
        .then(({ data: { data: currentBookings } }) => {
          commit("SET_BOOKINGS", currentBookings);
          dispatch("filterBookingsByTime");
        });
      window
        .axios({
          method: "get",
          url: "/booking/getWaitingAppoinment",
          params: {
            dates: moment(moment.now()).format("MM-DD-YYYY"),
          },
        })
        .then(({ data: { data: todaysBookings } }) => {
          todaysBookings.sort((a, b) => {
            const time1 = a.services[0].time;
            const time2 = b.services[0].time;
            if (time1 > time2) {
              return 1;
            }
            if (time1 < time2) {
              return -1;
            }
            return 0;
          });
          commit("SET_TODAYS_BOOKINGS", todaysBookings);
        });
    },
    async getAdToDisplay({ commit }) {
      const { data } = await window.axios({
        method: "get",
        url: "/ad/toDisplay",
      });
      commit("SET_AD", data.body);
    },
    async getAdFile({ commit, state }, { id, filePath }) {
      if (state.imageCache[filePath]) {
        commit("UPDATE_CACHE_ENTRY", filePath);
        return state.imageCache[filePath].image;
      } else {
        const { data } = await window.axios({
          method: "get",
          url: "/ad/getFile/" + id,
        });
        commit("CACHE_IMAGE", { data, filePath });
        return data;
      }
    },
    async postAdCompletion({ commit }) {
      const { data } = await window.axios({
        method: "post",
        url: "/adPlayRecord",
      });
      commit("SET_AD", undefined);
    },
    getLiveSettings({ commit }) {
      window
        .axios({
          method: "get",
          url: "/liveDisplaySettings",
        })
        .then(async ({ data }) => {
          const columnSettings = {};
          const {
            language,
            showEntireDaysBookings,
            columns,
            slides,
            slideDuration,
          } = data.data;
          columns.map((column) => {
            columnSettings[column.key] = column.hidden;
          });
          commit("SET_SETTINGS", {
            primaryLanguage: language,
            showEntireDaysBookings,
          });
          commit("UPDATE_COLUMN_SETTINGS", columnSettings);
          commit("SET_SLIDE_DURATION", slideDuration);

          const toDataUrl = (url, callback, resolve) => {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
              var reader = new FileReader();
              reader.onloadend = function() {
                callback(reader.result);
              };
              reader.readAsDataURL(xhr.response);
            };
            xhr.onerror = function(e) {
              resolve();
            };
            xhr.open("GET", url);
            xhr.responseType = "blob";
            xhr.send();
          };
          const imageCacheMap = {};
          await Promise.all(
            slides.map((slide) => {
              return new Promise((resolve) => {
                const url = slide.content.url
                if (slide.content.resourceType == "image") {
                  if (url) {
                    toDataUrl(
                      !url.includes("https") ? url.replace("http", "https") : url,
                      (cachedImage) => {
                        imageCacheMap[slide._id] = {
                          type: slide.content.resourceType,
                          url: cachedImage,
                        };
                        resolve();
                      },
                      resolve
                    );
                  } else {
                    resolve();
                  }
                } else {
                  imageCacheMap[slide._id] = {
                    type: slide.content.resourceType,
                    url: url,
                  };
                  resolve();
                }
              });
            })
          );
          commit("SET_SLIDES", imageCacheMap);
        });
    },
    setUserId({ commit }, userId) {
      commit("SET_USER_ID", userId);
    },
    setToken({ commit }, token) {
      commit("SET_TOKEN", token);
    },
    filterBookingsByTime({ commit, state }) {
      try {
        const bookings = state.currentBookings;
        const today = moment(moment.now()).tz("America/Montreal");
        let currentMinute = Math.ceil(today.format("mm"));
        let currentHour = parseInt(today.format("HH"));
        const newBookings = bookings.filter((booking) => {
          let serviceDuration = parseInt(
            getNestedValue(
              booking,
              ["services", 0, "serviceId", "duration"],
              15
            )
          );
          if (isNaN(serviceDuration)) {
            serviceDuration = 15;
          }
          let serviceHour = booking.services[0].time.split(":")[0];
          let serviceMinute =
            parseInt(booking.services[0].time.split(":")[1]) +
            serviceDuration +
            15;
          if (serviceMinute > 60) {
            serviceMinute = serviceMinute % 60;
            serviceHour++;
          }
          if (serviceHour > currentHour) {
            return true;
          } else if (serviceHour == currentHour) {
            return serviceMinute > currentMinute;
          } else {
            return false;
          }
        });
        commit("UPDATE_FILTERED_BOOKINGS", newBookings);
      } catch (e) {
        console.error(e);
      }
    },
    setCompany({ commit }, company) {
      commit("SET_COMPANY", company);
    },
  },
  mutations: {
    SET_SETTINGS(state, settings) {
      Vue.set(state, "settings", { ...state.settings, ...settings });
    },
    SET_USER_ID(state, userId) {
      Vue.set(state, "userId", userId);
    },
    SET_TOKEN(state, token) {
      Vue.set(state, "token", token);
    },
    SET_SLIDES(state, slides) {
      Vue.set(state, "slides", slides);
    },
    SET_SLIDE_DURATION(state, slideDuration) {
      Vue.set(state, "slideDuration", slideDuration);
    },
    SET_BOOKINGS(state, currentBookings) {
      Vue.set(state, "currentBookings", currentBookings);
    },
    UPDATE_WEATHER(state, { icon, temp }) {
      state.weather = {
        temp,
        icon,
      };
    },
    SET_AD(state, ad) {
      state.ad = ad;
    },
    CACHE_IMAGE(state, { data, filePath }) {
      state.imageCache[filePath] = {
        image: data,
        last_used: Date.now(),
      };
    },
    UPDATE_CACHE_ENTRY(state, filePath) {
      state.imageCache[filePath] = {
        ...state.imageCache[filePath],
        last_used: Date.now(),
      };
    },
    CLEAR_CACHE_ENTRY(state, filePath) {
      Vue.delete(state.imageCache, cacheKey);
    },
    UPDATE_COLUMN_SETTINGS(state, columnSettings) {
      Vue.set(state, "columnSettings", columnSettings);
    },
    UPDATE_CHANNEL(state, channel) {
      Vue.set(state, "channel", channel);
    },
    UPDATE_FILTERED_BOOKINGS(state, filteredBookings) {
      Vue.set(state, "filteredBookings", filteredBookings);
    },
    SET_TODAYS_BOOKINGS(state, todaysBookings) {
      Vue.set(state, "todaysBookings", todaysBookings);
    },
    SET_COMPANY(state, company) {
      Vue.set(state, "company", company);
    },
  },
});
